var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"send-request-reply-message pt-1 pr-2 pb-1 pl-2"},[_c('div',{staticClass:"datetime mb-2"},[_vm._v(_vm._s(_vm._datetime))]),_c('div',{staticClass:"message-text pre-line"},[_vm._v(_vm._s(_vm._messageText))])])}
var staticRenderFns = []

export { render, staticRenderFns }